import { FunctionComponent } from 'react';
import { useIsEmbed } from '../../../../../../contexts/AppContext/useIsEmbed';
import useEmbedExternalLinkProps from '../../../../../../hooks/useEmbedExternalLinkProps';
import ButtonLink, { ButtonLinkProps } from '../../../../../ButtonLink';

type BookButtonProps = {
    buttonLabel: string;
    href: string;
    preset: ButtonLinkProps['preset'];
};

export const BookButton: FunctionComponent<BookButtonProps> = ({ buttonLabel, href, preset }) => {
    const isEmbed: boolean = useIsEmbed();
    const { target, rel } = useEmbedExternalLinkProps(isEmbed);

    return (
        <ButtonLink href={href} target={target} rel={rel} preset={preset}>
            {buttonLabel}
        </ButtonLink>
    );
};
